/* src/app/modules/institutions/institutions-data/institutions-data.component.scss */
:host {
  max-width: 100%;
}
.cw-region-assignments > p:not(:last-of-type) {
  margin: 0 0 5px;
}
/*# sourceMappingURL=institutions-data.component.css.map */
